import React from 'react';

export default function DashboardSkeleton() {
  return (
    <div className="space-y-6">
      {/* KPI Grid Skeleton */}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-4 gap-4">
        {/* Hero card — 2 cols */}
        <div className="sm:col-span-2 xl:col-span-2 2xl:col-span-2 min-h-[140px] skeleton-shimmer" />
        {/* Avg card */}
        <div className="min-h-[110px] skeleton-shimmer" />
        {/* Min/Max stacked */}
        <div className="grid grid-cols-2 xl:grid-cols-1 2xl:grid-cols-1 gap-4">
          <div className="min-h-[110px] skeleton-shimmer" />
          <div className="min-h-[110px] skeleton-shimmer" />
        </div>
      </div>
      {/* Chart Card Skeleton */}
      <div className="rounded-md border border-border p-5 sm:p-6 bg-card">
        {/* Chart header */}
        <div className="flex items-center justify-between mb-5">
          <div className="space-y-2">
            <div className="h-3 w-36 skeleton-shimmer" />
            <div className="h-3 w-52 skeleton-shimmer" />
          </div>
          <div className="flex gap-3">
            {['sk-l1', 'sk-l2', 'sk-l3', 'sk-l4', 'sk-l5']?.map((k) => (
              <div key={k} className="h-3 w-16 skeleton-shimmer" />
            ))}
          </div>
        </div>

        {/* Chart bars skeleton */}
        <div className="w-full h-[320px] sm:h-[380px] flex items-end gap-1 px-2 pb-8">
          {Array.from({ length: 24 })?.map((_, i) => (
            <div
              key={`skel-bar-${i}`}
              className="flex-1 skeleton-shimmer rounded-sm"
              style={{ height: `${30 + ((i * 17 + i * i * 3) % 60)}%` }}
            />
          ))}
        </div>
      </div>
      {/* Footer skeleton */}
      <div className="h-4 w-64 skeleton-shimmer" />
    </div>
  );
}